import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "sonner";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ServersPage from "@/pages/ServersPage";
import MappingsPage from "@/pages/MappingsPage";
import AuditPage from "@/pages/AuditPage";
import SettingsPage from "@/pages/SettingsPage";
import SSOHandoffPage from "@/pages/SSOHandoffPage";
import "@/App.css";

function ProtectedShell({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-border border-t-primary" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/sso/cpanel" element={<SSOHandoffPage />} />
      <Route path="/" element={<ProtectedShell><DashboardPage /></ProtectedShell>} />
      <Route path="/servers" element={<ProtectedShell><ServersPage /></ProtectedShell>} />
      <Route path="/mappings" element={<ProtectedShell><MappingsPage /></ProtectedShell>} />
      <Route path="/audit" element={<ProtectedShell><AuditPage /></ProtectedShell>} />
      <Route path="/settings" element={<ProtectedShell><SettingsPage /></ProtectedShell>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster richColors position="top-right" closeButton />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
